import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//Components
import { ToolsService } from 'src/app/services/tools.service'

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {

  constructor(
    public toolsService: ToolsService,
    public router: Router
  ) { 
  }

  ngOnInit() {
  }

  //Function to go to home and reset breadcrumbs
  goToRoot(){
    this.router.navigate(['inicio'])
    this.toolsService.resetBreadCrumbs()
  }

  //Function to go to another page
  goToBreadCrumb(breadcrumb){
    this.router.navigate([breadcrumb.path])
  }
}
